import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import ReturnNoteDetail from './ReturnNoteDetail';
import './ReturnNoteDetail.less';

export const prefix = 'bm-p-return-note-detail';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: ReturnNoteDetail,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
